import { api, withStatus } from '@/lib/apiClient';

// Uploads go over the user's connection, so allow longer than apiClient's 30s default.
const UPLOAD_TIMEOUT_MS = 120_000;

export async function uploadNutritionPdf(file: File): Promise<string> {
  const formData = new FormData();
  formData.append('file', file);

  // FormData is passed through untouched (browser sets the multipart boundary).
  const res = await api.post<unknown>('/api/nutrition-pdfs/upload', formData, { timeout: UPLOAD_TIMEOUT_MS });

  if (!res.ok) {
    const err = (res.body ?? {}) as { error?: string; message?: string };
    throw new Error(err.error || err.message || withStatus(res, (status) => `Failed to upload PDF (${status})`));
  }

  return String((res as { objectPath?: string }).objectPath || '');
}

export async function getNutritionPdfSignedUrl(objectPath: string, expiresIn: number = 300): Promise<string> {
  const res = await api.post<unknown>('/api/nutrition-pdfs/sign-url', { objectPath, expiresIn });
  if (!res.ok) {
    const err = (res.body ?? {}) as { error?: string; message?: string };
    throw new Error(err.error || err.message || withStatus(res, (status) => `Failed to get signed URL (${status})`));
  }
  const signedUrl = String((res as { signedUrl?: string }).signedUrl || '');
  if (!signedUrl) {
    throw new Error('Signed URL response was empty');
  }
  return signedUrl;
}
